import * as React from 'react';
import { cn } from '../lib/utils';

export interface ListRowProps extends React.HTMLAttributes<HTMLDivElement> {
  title: string;
  description?: string;
  action?: React.ReactNode;
}

const ListRow = React.forwardRef<HTMLDivElement, ListRowProps>(
  ({ className, title, description, action, ...props }, ref) => (
    <div ref={ref} className={cn('flex items-start justify-between gap-4', className)} {...props}>
      <div className="min-w-0">
        <p className="type-body-sm font-medium text-foreground">{title}</p>
        {description ? <p className="type-body-sm text-muted-foreground">{description}</p> : null}
      </div>
      {action ? <div className="shrink-0">{action}</div> : null}
    </div>
  ),
);
ListRow.displayName = 'ListRow';

export { ListRow };
